type Props = {
  mensaje: string
}

/**
 * Overlay de carga con spinner animado y mensaje personalizado.
 * Se usa en formularios/acciones asincronas que bloquean la interaccion.
 */
export const Cargando = ({ mensaje }: Props) => {
  return (
    <div className='overlay-layer rounded bg-white bg-opacity-60'>
      <div className='d-flex align-items-center flex-column'>
        <div className='sk-chase'>
          <div className='sk-chase-dot'></div>
          <div className='sk-chase-dot'></div>
          <div className='sk-chase-dot'></div>
          <div className='sk-chase-dot'></div>
          <div className='sk-chase-dot'></div>
          <div className='sk-chase-dot'></div>
        </div>
        <h3 className='fw-lighter my-10'>{mensaje}</h3>
      </div>
    </div>
  )
}
